import React, {useEffect} from "react";

type ModalConfirmType = {
    cancelText: string,
    confirmText: string,
    onConfirm: () => void,
    onClose: () => void,
    isOpen: boolean,
    title: string,
    text: string
}
const ModalConfirm = ({cancelText, confirmText, onConfirm, onClose, isOpen, title, text}: ModalConfirmType) => {

    const [isShow, setIsShow] = React.useState(false);

    useEffect(()  => {
        setIsShow(isOpen);
    }, [isOpen])

    return <div className={`modal shift-up fixed inset-0 z-[100] flex flex-col items-center justify-center overflow-hidden px-4 py-6 sm:px-5 ${isShow && 'show'}`}>
        <div className="modal-overlay absolute inset-0 bg-slate-900/60"></div>
        <div className="modal-content scrollbar-sm relative flex max-w-md flex-col overflow-y-auto rounded-lg bg-white pb-4 pt-10 text-center dark:bg-navy-700">
            <div className="mt-4 px-4 sm:px-12">
                <h3 className="text-lg text-slate-800 dark:text-navy-50">
                    {title}
                </h3>
                <p className="mt-1 text-slate-500 dark:text-navy-200">
                    {text}
                </p>
            </div>
            <div className="my-4 mt-16 h-px bg-slate-200 dark:bg-navy-500"></div>

            <div className="space-x-3">
                <button onClick={onClose} className="btn min-w-[7rem] rounded-full border border-slate-300 font-medium text-slate-800 hover:bg-slate-150 focus:bg-slate-150 active:bg-slate-150/80 dark:border-navy-450 dark:text-navy-50 dark:hover:bg-navy-500 dark:focus:bg-navy-500 dark:active:bg-navy-500/90">
                    {cancelText}
                </button>
                <button onClick={onConfirm} className="btn min-w-[7rem] rounded-full bg-primary font-medium text-white hover:bg-primary-focus focus:bg-primary-focus active:bg-primary-focus/90 dark:bg-accent dark:hover:bg-accent-focus dark:focus:bg-accent-focus dark:active:bg-accent/90">
                    {confirmText}
                </button>
            </div>
        </div>
    </div>;

}

export default ModalConfirm;
